import { render, staticRenderFns } from "./PurchaseListNew.vue?vue&type=template&id=315c7751&scoped=true"
import script from "./PurchaseListNew.vue?vue&type=script&lang=js"
export * from "./PurchaseListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c7751",
  null
  
)

export default component.exports